/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ── Header: center logo in bar__c ──────────────────────────────────────────
  var s = document.createElement('style');
  s.textContent = '.header__desktop__upper .header__desktop__bar__c{justify-content:center}';
  document.head.appendChild(s);

  // ── Homepage: full-width hero logo that fades out on scroll ────────────────
  //
  // Approach:
  //   • A <div id="aajiya-hero-logo"> is server-rendered in theme.liquid
  //     (homepage only) containing the actual logo SVG — no JS cloning.
  //   • It sits fixed, full-viewport, above everything.
  //   • The header logo is hidden while the hero is fully visible.
  //   • On scroll the hero fades out; at threshold the header logo fades in.
  //   • Transparent header (white nav text) is enabled on homepage in settings.

  if (!document.body.classList.contains('template-index')) return;

  var heroEl  = document.getElementById('aajiya-hero-logo');
  if (!heroEl) return;

  // ── Inject styles ──────────────────────────────────────────────────────────
  var hs = document.createElement('style');
  hs.textContent = [

    // Hero element: fixed, full-screen, top-aligned with 50px padding, above header (z 400)
    '#aajiya-hero-logo {',
    '  position: fixed !important;',
    '  top: 0 !important;',
    '  left: 0 !important;',
    '  width: 100vw !important;',
    '  height: 100vh !important;',
    '  display: flex !important;',
    '  align-items: flex-start !important;',
    '  justify-content: center !important;',
    '  padding-top: 50px !important;',
    '  z-index: 400;',
    '  pointer-events: none;',
    '  opacity: 1;',
    '  transition: opacity 0.35s ease;',
    '}',

    // Logo image: full width
    '#aajiya-hero-logo img {',
    '  width: 100vw !important;',
    '  max-width: 100vw !important;',
    '  height: auto !important;',
    '  display: block !important;',
    '}',

    // While hero is visible, hide the header logo so there's only one
    'body.hero-logo-visible .header__logo { opacity: 0 !important; transition: opacity 0.35s ease !important; }',
    'body.hero-logo-visible .header__logo { pointer-events: none; }',

  ].join('');
  document.head.appendChild(hs);

  // ── Scroll logic ───────────────────────────────────────────────────────────
  var FADE_END = window.innerHeight * 0.35; // fully faded by 35vh scroll

  function update() {
    var scrollY = window.scrollY;
    var progress = Math.min(scrollY / FADE_END, 1); // 0 → 1

    heroEl.style.opacity = 1 - progress;

    if (progress >= 1) {
      // Hero fully gone — show header logo, disable hero pointer events
      document.body.classList.remove('hero-logo-visible');
      heroEl.style.display = 'none';
    } else {
      heroEl.style.display = '';
      document.body.classList.add('hero-logo-visible');
    }
  }

  // Start with hero visible
  document.body.classList.add('hero-logo-visible');
  window.addEventListener('scroll', update, { passive: true });
  update(); // run immediately in case page loaded mid-scroll

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
